import { Vue, Component, Ref, Prop, Emit } from 'vue-property-decorator'
import ConfigurationLocalAccountingBillableRateModalBasicForm from '@/modules/configurationModule/detail/local-accounting/billable/rates/components/rates-modal-basic-form/configuration-local-accounting-billable-rate-modal-basic-form.vue'
import ConfigurationLocalAccountingBillableRateModalConceptsGrid from '@/modules/configurationModule/detail/local-accounting/billable/rates/components/rates-modal-concepts-grid/configuration-local-accounting-billable-rate-modal-concepts-grid.vue'
import { BModal } from 'bootstrap-vue'
import { ConfigurationLocalAccountingRatesModalState, ConfigurationLocalAccountingRatesModalTabIndex, initialConfigurationLocalAccountingRatesModalState } from '@/modules/configurationModule/detail/local-accounting/billable/rates/components/rates-modal/configuration-local-accounting-billable-rate-modal.model'
import { StrictNullable } from '@/shared/types/app.types'
import { BillableRateResponse } from '@/modules/configurationModule/detail/local-accounting/billable/rates/services/configuration-local-accounting-billable-rates/billable-rate.dto'

@Component({
    components: {
        ConfigurationLocalAccountingBillableRateModalBasicForm,
        ConfigurationLocalAccountingBillableRateModalConceptsGrid
    }
})
export default class ConfigurationLocalAccountingBillableRateModal extends Vue {
    @Ref() readonly ratesModal!: BModal

    @Prop(String) readonly actionTitle!: string

    @Emit()
    create(): void {}

    @Emit()
    update(): void {}

    state: ConfigurationLocalAccountingRatesModalState
    constructor() {
        super()
        this.state = initialConfigurationLocalAccountingRatesModalState()
    }

    get isConceptsDisabled(): boolean {
        return !this.state.rate?.id && !this.state.showConceptsTab
    }

    async show(rate: StrictNullable<BillableRateResponse>): Promise<void> {
        await this.$validator.reset()
        this.state.showModal = true
        if (rate) {
            this.state.rate = rate
        } else {
            this.state.rate = null
        }
        this.state.actionTitle = this.actionTitle
        this.$nextTick(() => {
            this.ratesModal.show()
        })
    }

    hide(): void {
        this.ratesModal.hide()
        this.state.showModal = false
    }

    onCreateRate(createdRate: StrictNullable<BillableRateResponse>): void {
        this.state.showConceptsTab = true
        this.state.rate = createdRate
        this.create() // emits an event

        // wait for the DOM update (when Concepts tab is active)
        this.$nextTick(() => {
            this.state.actionTitle = this.$tc('configuration.actions.update')
            this.state.activeTabIndex = ConfigurationLocalAccountingRatesModalTabIndex.CONCEPTS
        })
    }

    onUpdateRate(updatedRate: BillableRateResponse) {
        this.state.rate = updatedRate
        this.update() // emits an event
    }
}
